import { useContext } from 'react';
import { incaAccessor } from '@cancercentrum/inca';
import { IncaContext } from '../components/ScopedIncaContext/IncaContext';
export const useIsReviewer = ()=>{
    const ctx = useContext(IncaContext);
    if (ctx) {
        return ctx.currentUser.role.permissions.includes('WORKFLOW_FUNCTION_REVIEWER');
    }
    return incaAccessor().user.role.isReviewer;
};
